// dependencies
import React, { useRef, useState, useEffect } from 'react'
// import toast from '_root/lib/toast.js'
import PropTypes from 'prop-types'

// components
import { Button, BUTTON_THEME, Input } from '@st-operations/uikit/src/v2/index.js'

// lib
import sendAnalytics from '@st-operations/uikit/lib/sendAnalytics.js'

// styles
import './styles.scss'

// component
const NewEntityDialog = ({
  value,
  open,
  title,
  label,
  defaultProperties,
  urlRedirect,
  entities,
  close,
  queryParam,
}) => {
  const [inputValue, setInputValue] = useState('')

  const inputRef = useRef()

  useEffect(() => {
    if (value) {
      setInputValue(value)
    }
  }, [value])

  useEffect(() => {
    if (open) {
      inputRef.current.focus()
    }
  }, [open])

  const onCreate = () => {
    // construct endpoint conditionally based on queryParam
    const endpoint = queryParam ? `/${entities}?${queryParam}` : `/${entities}`
    window._api.post(`${endpoint}`, { name: inputValue, ...defaultProperties }, (error, item) => {
      if (error) {
        toast.error(error.message)
      } else {
        close()
        if (urlRedirect) {
          window._history.push(`/${urlRedirect}/${item._id}`)
        } else {
          window._history.push(`/${entities}/${item._id}`)
        }
      }

      // event tracking
      sendAnalytics('create', entities, item)
    })
  }

  const onDismiss = () => {
    close()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onCreate()
    }
    if (e.key === 'Escape' || (e.metaKey && e.key === 'e')) {
      e.preventDefault()
      onDismiss()
    }
  }

  const updateName = (value) => {
    setInputValue(value)
  }

  return (
    <section className="st-new-entity-modal">
      <If condition={title}>
        <h1 className="st-new-entity-modal__title">{title}</h1>
      </If>
      <Input
        ref={inputRef}
        onChange={updateName}
        onKeyDown={onKeyDown}
        value={inputValue}
        label={label}
        classes={{
          root: 'st-new-entity-modal__input',
          input: 'st-new-entity-modal__input-field',
        }}
      />
      <div className="st-new-entity-modal__buttons">
        <Button
          className="st-new-entity-modal__button"
          theme={BUTTON_THEME.SECONDARY}
          onClick={onDismiss}
        >
          Back
        </Button>
        <Button className="st-new-entity-modal__button" onClick={onCreate}>
          Create
        </Button>
      </div>
    </section>
  )
}

NewEntityDialog.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  open: PropTypes.bool,
  defaultProperties: PropTypes.shape(),
  urlRedirect: PropTypes.string,
  entities: PropTypes.string,
  value: PropTypes.string,
  close: PropTypes.func,
  queryParam: PropTypes.string,
}

NewEntityDialog.defaultProperties = {
  title: '',
  label: 'Name',
  open: false,
  defaultProperties: {},
  urlRedirect: '',
  entities: '',
  value: '',
  close: () => {},
  queryParam: '',
}

// export
export default React.memo(NewEntityDialog)
